import { Routes, Route } from "react-router-dom"; 
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import ReportSearch from "./pages/ReportSearch";
import Report from "./components/reports/Report";
import Layout from "./components/layout/Layout";
import PrivateRoute from "./components/routes/PrivateRoute";
import ProtectedLoginRoute from "./components/routes/ProtectedLoginRoute";
import Admin from "./pages/Admin";
function App() {
    return (
        <Routes>
            <Route element={<PrivateRoute />}>
                <Route path="/Report" element={<Report />} />
            </Route>
            <Route element={<Layout />}>
                <Route key='Landing' path='/' element={<Landing />} />
                <Route element={<ProtectedLoginRoute />}>
                    <Route key='Login' path='/Login' element={<Login />} />
                </Route>
                <Route element={<PrivateRoute />}>
                    <Route key='Report Search' path='/ReportSearch' element={<ReportSearch />} />
                </Route>
                <Route element={<PrivateRoute />}>
                    <Route key='Admin ' path='/Admin ' element={<Admin />} />
                </Route>
            </Route>
        </Routes>
    );
}

export default App;